import { defineStore } from 'pinia'

function emptyState() {
  return {
    business: { process: new Set(), queue: new Set() },
    operations: { process: new Set(), queue: new Set() }
  }
}

export const useGroupFilterStore = defineStore('groupFilter', {
  state: () => ({
    excluded: emptyState()
  }),
  actions: {
    getExcluded(page, kind) {
      return this.excluded[page][kind]
    },
    setExcluded(page, kind, set) {
      this.excluded[page][kind] = new Set(set)
    },
    toggleGroup(page, kind, id) {
      const set = this.excluded[page][kind]
      if (set.has(id)) {
        set.delete(id)
      } else {
        set.add(id)
      }
    },
    isVisible(page, kind, groupId) {
      const set = this.excluded[page][kind]
      return set.size === 0 || !set.has(groupId)
    }
  }
})
